var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wsgwdv0jwa",
    d: "M4 0h24c2.21 0 4 1.79 4 4v24c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179 -172) translate(179 172)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#EDF2F8",
    opacity: 0.8,
    xlinkHref: "#wsgwdv0jwa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0A8CE0",
    d: "M2.4 0h16.8c1.325 0 2.4 1.075 2.4 2.4v4.8c0 1.325-1.075 2.4-2.4 2.4H2.4C1.075 9.6 0 8.525 0 7.2V2.4C0 1.075 1.075 0 2.4 0z",
    transform: "translate(-179 -172) translate(179 172) translate(5 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M3.97 7.24v-1.6h.95c1.069 0 1.81-.696 1.81-1.736 0-1.044-.717-1.737-1.757-1.737H2.909V7.24h1.062zm.718-2.43h-.717V3.008h.72c.609 0 .96.324.96.9 0 .58-.355.904-.963.904zm4.284 2.43V3.918h.032l2.373 3.322h.88V2.167H11.24v3.305h-.028l-2.37-3.305h-.886V7.24h1.016zm7.013.088c1.413 0 2.25-.837 2.25-2.218v-.574h-2.138v.774h1.104l-.003.08c-.021.63-.503 1.055-1.195 1.055-.844 0-1.379-.671-1.379-1.771 0-1.08.503-1.716 1.34-1.716.573 0 1.005.316 1.16.847h1.065C18.04 2.78 17.145 2.08 15.96 2.08c-1.49 0-2.418.984-2.418 2.609 0 1.648.928 2.64 2.443 2.64z",
    transform: "translate(-179 -172) translate(179 172) translate(5 19)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#59709B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15-.5c.69 0 1.315.28 1.768.732C17.22.685 17.5 1.31 17.5 2h0v7c0 .69-.28 1.315-.732 1.768-.453.452-1.078.732-1.768.732h0H3c-.69 0-1.315-.28-1.768-.732C.78 10.315.5 9.69.5 9h0V2c0-.69.28-1.315.732-1.768C1.685-.22 2.31-.5 3-.5h0z",
    transform: "translate(-179 -172) translate(179 172) translate(7 5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.603 9.808L6.682 4 10.495 8.444 13.462 6.193 17.235 9.255M13.5 3.75c0-.966-.784-1.75-1.75-1.75S10 2.784 10 3.75",
    transform: "translate(-179 -172) translate(179 172) translate(7 5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPng);
export default __webpack_public_path__ + "static/media/ic-png.51eceddc92cbfb15d0286603f9fe2a67.svg";
export { ForwardRef as ReactComponent };